import React from 'react';

import { Container, Typography } from '@mui/material';

function ForgotPassword() {
	return (
		<Container>
			{' '}
			<Typography variant="h4"> Passwort vergessen</Typography>
		</Container>
	);
}

export default ForgotPassword;
